import React from "react";
import { useNavigate } from "react-router-dom";

export default function MyServicesBox() {
  const navigate = useNavigate();

  const galleryItems = [
    {
      id: 1,
      images: ["/images/app/custombuild.jpg"],
      title: "Custom Build",
      description:
        "Design a home that suits your needs, tastes, and lifestyle by building a bespoke home.",
      onClick: () => navigate("/custom") ,
    },
    {
      id: 2,
      images: ["/images/app/web-design.jpg"],
      title: "Home Designs",
      description: "View our home design options and contact us for details.",
      onClick: () => navigate("/town"),
    },
    {
      id: 3,
      images: ["/images/app/knockdownrebuild.jpg"],
      title: "Knock Down Rebuild",
      description:
        "Knocking down and rebuilding, constructing something new in place of an existing structure.",
      onClick: () => {navigate("/know")},
    },
    {
      id: 4,
      images: ["/images/app/currentprojects.jpg"],
      title: "Current Projects",
      description:
        "Variety of designs ranging from contemporary to historic row houses.",
      onClick: () => {navigate("/gallery") },
    },
  ];

  return (
    <section className="services-section">
      <div className="services-grid">
        {galleryItems.map((item) => (
          <div className="service-card" key={item.id}>
            <div className="service-image">
              <img src={item.images[0]} alt={item.title} />
            </div>
            <div className="service-content">
              <h2 className="service-title">{item.title}</h2>
              <p className="service-description">{item.description}</p>
              <button className="service-btn" onClick={item.onClick}>
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
